import { t } from '@web/i18n';
import { formatRawDate } from '@web/ui/core';
import type { PremisesForm } from './premises_form';

/** Hoje na data local do navegador (AAAA-MM-DD), para comparar com a data do evento. */
function localToday(): string {
  const now = new Date();
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${String(now.getFullYear())}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/**
 * Sinais de premissas incoerentes (vistos num teste real: todos os destinos como último recurso,
 * data do evento digitada errada). Só avisa; quem decide é o operador. Destino sem IATA não conta.
 */
function warningsOf(form: PremisesForm, eventDate: string): string[] {
  const destinations = form.destinations.filter((d) => d.iata.trim() !== '');
  const warnings: string[] = [];
  if (destinations.length > 0 && destinations.every((d) => d.lastResort)) {
    warnings.push(t('mice.premises.warning.allLastResort'));
  }
  if (destinations.length > 0 && destinations.every((d) => d.arrivalIdeal === '')) {
    warnings.push(t('mice.premises.warning.noIdealArrival'));
  }
  if (eventDate !== '' && eventDate < localToday()) {
    warnings.push(
      t('mice.premises.warning.pastEventDate', { date: formatRawDate(eventDate, null) }),
    );
  }
  return warnings;
}

export function PremisesWarnings({
  form,
  eventDate,
}: Readonly<{ form: PremisesForm; eventDate: string }>): React.JSX.Element | null {
  const warnings = warningsOf(form, eventDate);
  if (warnings.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1">
      {warnings.map((w) => (
        <li key={w} className="text-meta text-tone-amber-ink">
          {w}
        </li>
      ))}
    </ul>
  );
}
